import { render } from "./NewsletterSection.vue?vue&type=template&id=0ddb3049&scoped=true"
import script from "./NewsletterSection.vue?vue&type=script&lang=js"
export * from "./NewsletterSection.vue?vue&type=script&lang=js"

import "./NewsletterSection.vue?vue&type=style&index=0&id=0ddb3049&scoped=true&lang=css"

import exportComponent from "/home/armin/w/euro-petrol-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ddb3049"]])

export default __exports__